import React from 'react';
import { Carousel, Grid } from 'antd';

import AppHeader from '../../../../Layout/Header';
import FooterComponent from '../../../../Layout/Footer';
import SummerSchoolVideoArchive from './SummerSchoolVideoArchive';
import SummerSchoolMediaCoverage from './SummerSchoolMediaCoverage';

import banner from '../../../../Assets/Linkages/SpaceSummerSchool/Space-Summer-School-Banner.jpg';

import summerSchoolImageOne from '../../../../Assets/Linkages/SpaceSummerSchool/Summer-School-01.jpeg';
import summerSchoolImageTwo from '../../../../Assets/Linkages/SpaceSummerSchool/Summer-School-02.jpg';
import summerSchoolImageThree from '../../../../Assets/Linkages/SpaceSummerSchool/Summer-School-03.jpg';

import decadePosterOne from '../../../../Assets/Linkages/SpaceSummerSchool/Decade-Poster-01.png';
import decadePosterTwo from '../../../../Assets/Linkages/SpaceSummerSchool/Decade-Poster-02.png';

import gallery2017 from '../../../../Assets/Linkages/SpaceSummerSchool/AnnualGallery/SSS-2017.jpg';
import gallery2018 from '../../../../Assets/Linkages/SpaceSummerSchool/AnnualGallery/SSS-2018.jpg';
import gallery2019 from '../../../../Assets/Linkages/SpaceSummerSchool/AnnualGallery/SSS-2019.jpg';
import gallery2020 from '../../../../Assets/Linkages/SpaceSummerSchool/AnnualGallery/SSS-2020.jpg';
import gallery2021 from '../../../../Assets/Linkages/SpaceSummerSchool/AnnualGallery/SSS-2021.jpg';
import gallery2022 from '../../../../Assets/Linkages/SpaceSummerSchool/AnnualGallery/SSS-2022.jpg';
import gallery2023 from '../../../../Assets/Linkages/SpaceSummerSchool/AnnualGallery/SSS-2023.jpg';
import gallery2024 from '../../../../Assets/Linkages/SpaceSummerSchool/AnnualGallery/SSS-2024.jpg';
import gallery2025 from '../../../../Assets/Linkages/SpaceSummerSchool/AnnualGallery/SSS-2025.jpg';
import gallery2026 from '../../../../Assets/Linkages/SpaceSummerSchool/AnnualGallery/SSS-2026.jpg';

import '../../../../Styles/Linkages&Outreach.css';
const { useBreakpoint } = Grid;





/* =========================================================
   INTRODUCTION CAROUSEL IMAGES
   ========================================================= */

const carouselImages = [
  {
    src: summerSchoolImageOne,
    alt: 'Space Summer School participants',
  },
  {
    src: summerSchoolImageTwo,
    alt: 'Space Summer School activities',
  },
  {
    src: summerSchoolImageThree,
    alt: 'Space Summer School learning session',
  },
];


/* =========================================================
   LEGACY POSTERS
   ========================================================= */

const annualGallery = [
  { src: gallery2026, year: '2026', edition: 'Tenth Space Summer School', album: 'https://www.facebook.com/media/set/?set=a.1647706730698147&type=3' },
  { src: gallery2025, year: '2025', edition: 'Ninth Space Summer School', album: 'https://www.facebook.com/media/set/?set=a.1314281920707298&type=3' },
  { src: gallery2024, year: '2024', edition: 'Eighth Space Summer School', album: 'https://www.facebook.com/media/set/?set=a.1014816313987195&type=3' },
  { src: gallery2023, year: '2023', edition: 'Seventh Space Summer School', album: 'https://www.facebook.com/media/set/?set=a.714891323979697&type=3' },
  { src: gallery2022, year: '2022', edition: 'Sixth Space Summer School', album: 'https://www.facebook.com/media/set/?set=a.447457750723057&type=3' },
  { src: gallery2021, year: '2021', edition: 'Fifth Space Summer School', album: 'https://www.facebook.com/media/set/?set=a.1287088480093309&type=3' },
  { src: gallery2020, year: '2020', edition: 'Fourth Space Summer School', album: 'https://www.facebook.com/media/set/?set=a.1287080056760818&type=3' },
  { src: gallery2019, year: '2019', edition: 'Third Space Summer School', album: 'https://www.facebook.com/media/set/?set=a.1609370649238542&type=3' },
  { src: gallery2018, year: '2018', edition: 'Second Space Summer School', album: 'https://www.facebook.com/media/set/?set=a.831919430317005&type=3' },
  { src: gallery2017, year: '2017', edition: 'First Space Summer School', album: 'https://www.facebook.com/media/set/?set=a.1611197142389226&type=3' },
];


/* =========================================================
   SPACE SUMMER SCHOOL COMPONENT
   ========================================================= */

const SpaceSummerSchool = () => {
  const screens = useBreakpoint();


  return (
    <>
      <AppHeader />


      <main className="space-summer-school-page">


        {/* =====================================================
            HERO BANNER
            ===================================================== */}

        <section className="space-summer-school-hero">

          <img
            className="space-summer-school-banner"
            src={banner}
            alt="Space Summer School"
          />

        </section>


        {/* =====================================================
            INTRODUCTION
            ===================================================== */}

        <section className="summer-school-overview">

          <div className="summer-school-overview-inner">


            {/* =================================================
                INTRODUCTION TEXT
                ================================================= */}

            <div className="summer-school-introduction">

              <div className="summer-school-content">

                <p className="summer-school-eyebrow">
                  Discover. Explore. Innovate.
                </p>

                <h1>
                  Introduction
                </h1>

                <div className="summer-school-title-line" />

                <p
                  className="summer-school-intro-text"
                  style={{
            fontSize: screens.xs ? '14px' : screens.sm ? '20px' : screens.lg ? '125px' : '25px',
            lineHeight: screens.xs ? '1.5' : '1.8',
            textAlign: 'justify',
            color: 'black' // Optional: custom color
          }} 
                >
                  Space Summer School is a dynamic annual program tailored
                  for school and college students, designed to ignite
                  curiosity and passion for space science, technology, and
                  its real-world applications. Through an engaging blend of
                  hands-on activities, interactive learning sessions, and
                  collaborative team projects, students explore exciting
                  domains such as Astronomy &amp; Astrophysics, Earth and
                  Environmental Sciences, Aviation, Rocketry, and Satellite
                  Technology. The program offers young minds a unique
                  opportunity to delve into the wonders of the universe while
                  developing critical thinking, creativity, and
                  problem-solving skills. By immersing participants in the
                  rapidly evolving world of space exploration, Space Summer
                  School aims to inspire the next generation of scientists,
                  engineers, and innovators who will shape the future of
                  space.
                </p>

              </div>

            </div>


            {/* =================================================
                INTRODUCTION GALLERY
                ================================================= */}

            <div
              className="summer-school-gallery"
              aria-label="Space Summer School gallery"
            >

              <div className="summer-school-gallery-inner">

                <Carousel
                  autoplay
                  autoplaySpeed={2500}
                  dots
                  effect="fade"
                >

                  {carouselImages.map((image, index) => (

                    <div
                      key={`${image.alt}-${index}`}
                      className="summer-school-slide"
                    >

                      <img
                        src={image.src}
                        alt={image.alt}
                      />

                    </div>

                  ))}

                </Carousel>

              </div>

            </div>

          </div>

        </section>


        {/* =====================================================
            A DECADE OF IMPACT
            ===================================================== */}

        <section className="summer-school-decade">

          <div className="summer-school-decade-inner">


            {/* Text */}

            <div className="summer-school-decade-copy">

              <p className="summer-school-eyebrow">
                Ten Years of Impact
              </p>

              <h2>
                A Decade of Inspiring Pakistan&apos;s Future Space Explorers
              </h2>

              <div className="summer-school-title-line" />

              <p  style={{
            fontSize: screens.xs ? '14px' : screens.sm ? '20px' : screens.lg ? '125px' : '25px',
            lineHeight: screens.xs ? '1.5' : '1.8',
            textAlign: 'justify',
            color: 'black' // Optional: custom color
          }} >
                For ten years, Space Summer School has turned youthful
                curiosity into genuine ambition, empowering young minds to
                dream boldly and reach beyond the horizon. Its legacy
                endures in the learners, innovators, and future space
                leaders it continues to inspire—a lasting testament to a
                shared passion for discovery.
              </p>

            </div>


            {/* Posters */}

            <div className="summer-school-poster-gallery">

              <figure
                className="
                  summer-school-poster
                  summer-school-poster-primary
                "
              >

                <img
                  src={decadePosterOne}
                  alt="Space Summer School decade poster"
                />

              </figure>


              <figure
                className="
                  summer-school-poster
                  summer-school-poster-secondary
                "
              >

                <img
                  src={decadePosterTwo}
                  alt="Space Summer School program poster"
                />

              </figure>

            </div>

          </div>

        </section>


        {/* =====================================================
            OUR LEGACY
            ===================================================== */}

        <section className="summer-school-legacy">

          <div className="summer-school-legacy-inner">


            {/* Legacy Heading */}

            <header className="summer-school-legacy-header">

              <p className="summer-school-eyebrow">
                2017–2026
              </p>

              <h2>
                A Decade in Frames
              </h2>

              <div className="summer-school-title-line" />

              <p  style={{
            fontSize: screens.xs ? '14px' : screens.sm ? '20px' : screens.lg ? '125px' : '25px',
            lineHeight: screens.xs ? '1.5' : '1.8',
            textAlign: 'justify',
            color: 'black' // Optional: custom color
          }} >
                Explore ten editions of Space Summer School, from the
                tenth program in 2026 back to the first gathering in 2017.
                Each year captures a new generation of students learning,
                building, collaborating, and discovering the possibilities
                of space science and technology. Select any year to visit
                its complete event album.
              </p>

            </header>


            <div className="summer-school-year-gallery">

              {annualGallery.map((item) => (

                <article className="summer-school-year-card" key={item.year}>

                  <a
                    className="summer-school-year-image"
                    href={item.album}
                    target="_blank"
                    rel="noreferrer"
                    aria-label={`Open the ${item.year} Space Summer School Facebook album`}
                  >
                    <img
                      src={item.src}
                      alt={`${item.edition} ${item.year}`}
                    />
                    <span className="summer-school-year-badge">{item.year}</span>
                  </a>

                  <div className="summer-school-year-content">
                    <h3>{item.edition}</h3>
                    <a href={item.album} target="_blank" rel="noreferrer">
                      View full album <span aria-hidden="true">&#8599;</span>
                    </a>
                  </div>

                </article>

              ))}

            </div>

          </div>

        </section>

        <SummerSchoolVideoArchive />

        <SummerSchoolMediaCoverage />

      </main>


      <FooterComponent />

    </>
  );
};


export default SpaceSummerSchool;
